import { supportedLanguages } from "../../../assets/i18h/appTranslation";
import { CLINICIAN_ROLES } from "../../../assets/appConstants";

export const REGISTRATION_SCENARIOS = {
  NEW_USER: "new_user",
  SUB_ACCOUNT: "sub_account",
};

/** @deprecated use RegistrationWizardState.getTotalSteps() for dynamic pipelines */
export const WIZARD_TOTAL_STEPS = 7;

export const PROFESSION_TITLES = [
  { value: "MD", label: "MD" },
  { value: "PT", label: "PT" },
  { value: "OT", label: "OT" },
  { value: "Nurse", label: "Nurse" },
  { value: "Admin", label: "Admin" },
  { value: "Other", label: "Other" },
];

export const GENDER_OPTIONS = [
  { value: "MALE", label: "Male" },
  { value: "FEMALE", label: "Female" },
  { value: "OTHER", label: "Other" },
];

export const LANGUAGE_LABELS = {
  en: "English",
  he: "Hebrew",
  ar: "Arabic",
  es: "Spanish",
  pt: "Portuguese",
  ru: "Russian",
};

export const AVAILABLE_LANGUAGES = Object.values(supportedLanguages);

export const ROLE_CHIP_CLASS = {
  [CLINICIAN_ROLES.OWNER]: CLINICIAN_ROLES.OWNER,
  [CLINICIAN_ROLES.ADMIN]: CLINICIAN_ROLES.ADMIN,
  [CLINICIAN_ROLES.BASE]: CLINICIAN_ROLES.BASE,
};

export const ROLE_LABELS = {
  [CLINICIAN_ROLES.OWNER]: "Owner",
  [CLINICIAN_ROLES.ADMIN]: "Admin",
  [CLINICIAN_ROLES.BASE]: "Base",
};

export const normalizeClinicianRole = (raw) => {
  const value = String(raw || "").toUpperCase();
  if (
    value.includes("OWNER") ||
    raw === CLINICIAN_ROLES.OWNER ||
    raw === "ROLE_CLINIC_OWNER" ||
    raw === "ROLE_SUPERUSER"
  ) {
    return CLINICIAN_ROLES.OWNER;
  }
  if (
    value.includes("ADMIN") ||
    raw === CLINICIAN_ROLES.ADMIN ||
    raw === "ROLE_CLINIC_ADMIN"
  ) {
    return CLINICIAN_ROLES.ADMIN;
  }
  if (
    raw === CLINICIAN_ROLES.BASE ||
    raw === "ROLE_CLINIC_BASE" ||
    value.includes("BASE")
  ) {
    return CLINICIAN_ROLES.BASE;
  }
  return CLINICIAN_ROLES.BASE;
};

export const ROLE_COPY = {
  [CLINICIAN_ROLES.BASE]:
    "Treat your assigned patients and collaborate in shared clinics.",
  [CLINICIAN_ROLES.ADMIN]:
    "Manage all patients, clinic settings, and libraries.",
  [CLINICIAN_ROLES.OWNER]:
    "Full clinic control, including managing clinician access.",
};

export const getExperienceYearsList = () => {
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let y = currentYear; y >= currentYear - 70; y--) {
    years.push(y);
  }
  return years;
};

export const DEMO_THERAPIST_ME_SUB_ACCOUNT = {
  firstName: "Jane",
  lastName: "Doe",
  clinicName: "Sunrise Physical Therapy",
  clinic: {
    name: "Sunrise Physical Therapy",
    defaultLanguage: supportedLanguages.es,
  },
  role: CLINICIAN_ROLES.BASE,
  isSubAccount: true,
  accountStatus: "INVITED",
  email: "jane.doe@example.com",
  phone: {
    intlNumber: "+15551234567",
    number: "15551234567",
    countryCode: "1",
    lineNumber: "5551234567",
  },
  languageForPatients: null,
  clinicianLanguage: null,
  profilePhotoUrl: null,
};

export const DEMO_THERAPIST_ME_NEW_USER = {
  firstName: "",
  lastName: "",
  clinicName: null,
  role: CLINICIAN_ROLES.OWNER,
  isSubAccount: false,
  email: "alex.owner@example.com",
  phone: null,
  languageForPatients: null,
  clinicianLanguage: null,
  profilePhotoUrl: null,
};

/** @deprecated use DEMO_THERAPIST_ME_SUB_ACCOUNT */
export const DEMO_THERAPIST_ME = DEMO_THERAPIST_ME_SUB_ACCOUNT;
